export const LTI_RESOURCE_LINK = 'LtiResourceLinkRequest';
export const LTI_DEEP_LINKING = 'LtiDeepLinkingRequest';
